// @flow
/* eslint-disable react/no-danger */
import React from 'react';
// import cn from 'classnames';
import { Title } from '../Title';
import css from './AuditorsOpinion.scss';

type Player = {
	ID: number,
	Name: string,
	Grade: number,
	IsStartLineup: boolean,
	Position: string,
	EditorRemark: string | any,
	Photo?: string,
};

type Props = {
	title: string,
	bestPlayer: Player,
	worstPlayer: Player,
};

export function AuditorsOpinion({ title, bestPlayer, worstPlayer }: Props) {
	const renderPlayer = (playerData, heading) => {
		return (
			<div className={css.player}>
				<h6 className={css.name}>{heading}</h6>
				<div className={css.info}>
					{playerData.Photo && <img src={playerData.Photo} alt={playerData.Name} className={css.photo} />}
					<div>
						<p>{`${playerData.Name}, ציון: ${playerData.Grade}`}</p>
						<p dangerouslySetInnerHTML={{ __html: playerData.EditorRemark }} />
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className={css.auditorsOpinion}>
			<Title title={title} className={css.title} />
			<div className={css.players}>
				{renderPlayer(bestPlayer, `השחקן המצטיין`)}
				{renderPlayer(worstPlayer, `השחקן המאכזב`)}
			</div>
		</div>
	);
}

AuditorsOpinion.propTypes = {};
